export default "__VITE_ASSET__1043ad6e__"